module.exports = new __parcel__URL__("neon-phrases-2.2c61694b.mp4").toString();